module.exports = __webpack_public_path__ + "img/SketchPng11e85456de893dbb975734537b257305a0ee242517e33fb83b3944e630e581f7.176f6b67.png";